module.exports = __webpack_public_path__ + "static/media/play-button-white.f8e6d9e1.svg";